<script setup lang="ts">
import {useStorePromoCode} from "~/composables/store/order/serviceForm";
import {useHandleGetServicePrice} from "~/composables/store/services/getServicePrice";

const nuxtApp = useNuxtApp()
const promoCode = useStorePromoCode()
const promoCodeText = ref('')
const promoCodeResult = ref({
  text: '',
  isError: false,
  isSuccess: false
})

const { t } = useI18n()

async function getServicePrice(clearPromoCode = false) {
  if (!promoCodeText.value.length && !clearPromoCode)
    return
  promoCode.value = promoCodeText.value.toString().toUpperCase()
  const { response, error } = await nuxtApp.runWithContext(() => useHandleGetServicePrice())

  if (error) {
    promoCode.value = ''
    if (error?.statusCode === 406) {
      promoCodeResult.value.text = t('order.promo_code.wrong_code')
      promoCodeResult.value.isError = true
      promoCodeResult.value.isSuccess = false
    } else {

    }
  } else if (response) {
    if (promoCode.value.length) {
      promoCodeResult.value.text = t('order.promo_code.code_activated')
      promoCodeResult.value.isError = false
      promoCodeResult.value.isSuccess = true
    }
  }
}

function clearPromoCode() {
  promoCode.value = ''
  promoCodeText.value = ''
  promoCodeResult.value = {
    text: '',
    isError: false,
    isSuccess: false
  }

  getServicePrice(true)
}
</script>

<template>
  <form @submit.prevent="getServicePrice" class="p-[1px]">
    <p class="md:mb-3 mb-2">
        <span
            v-if="promoCodeResult.text"
            class="font-semibold text-sm"
            :class="{
            'text-primary-red': promoCodeResult.isError,
            'text-primary-green': promoCodeResult.isSuccess
              }"
        >
          {{promoCodeResult.text}}
        </span>
      <span v-else>{{$t('order.promo_code.enter_code')}}</span>
    </p>
    <div v-if="promoCodeResult.isSuccess" class="flex items-center font-semibold bg-white justify-between gap-2 border border-secondary-600 h-[44px] rounded-md w-full p-2 outline border-none outline-primary-green outline-[1.5px]">
        <span>
          {{promoCode}}
        </span>
      <UIBtn
          @click="clearPromoCode"
          class="text-sm p-2 rounded-xl text-primary-red font-semibold"
          type="button"
      >
        {{ $t('input_forms.button.cancel') }}
      </UIBtn>
    </div>
    <div v-else class="flex gap-2">
      <input
          v-model="promoCodeText"
          @input="promoCodeResult = {
              text: '',
              isError: false,
              isSuccess: false
            }"
          :class="{
              'outline-primary-red outline': promoCodeResult.isError,
              'outline-primary-green outline': promoCodeResult.isSuccess,
            }"
          class="uppercase font-semibold border border-secondary-600 h-[44px] rounded-md w-full p-2 focus:outline outline-[1.5px]"
      />
      <UIBtn
          color="green"
          :disabled="!promoCodeText.length || promoCodeResult.isError"
          class="text-sm p-2 rounded-xl"
      >
        {{$t('input_forms.button.apply')}}
      </UIBtn>
    </div>
  </form>
</template>

<style scoped>

</style>